import { apiAgents } from "../../axios/apiAgentsInstance";

export const deleteAgent = async ({ id_agent, new_id_agent, token }) => {
	if (!id_agent) throw new Error('id_agent is required');
	if (!token) throw new Error('token is required');

	try {
		const { data } = await apiAgents.delete(`/${id_agent}`, {
			data: {
				new_id_agent: new_id_agent ?? null,
			},
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return data;
	} catch (error) {
		console.error('Error deleting agent:', error);
		throw error;
	}
};